import { render, staticRenderFns } from "./SelfUnassign.vue?vue&type=template&id=b72e3ed0"
import script from "./SelfUnassign.vue?vue&type=script&lang=js"
export * from "./SelfUnassign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports